const AppPeace = () => import("@/layout/AppPeace.vue");
const personManage = () => import("@/views/personManage/personManage.vue");
export default {
  path: "/",
  component: AppPeace,
  sort: 3,

  children: [
    {
      path: "/personManage",
      name: "personManage",
      component: personManage,
    },
  ],
};
